if (!customElements.get('product-modal')) {
  customElements.define(
    'product-modal',
    class ProductModal extends ModalDialog {
      constructor() {
  super();

  this.touchStartX = 0;
  this.touchStartY = 0;

  this.querySelector('.product-modal-mobile-prev')?.addEventListener('click', () => {
    this.changeMedia(-1);
  });

  this.querySelector('.product-modal-mobile-next')?.addEventListener('click', () => {
    this.changeMedia(1);
  });

  this.addEventListener('touchstart', (event) => {
    this.touchStartX = event.changedTouches[0].screenX;
    this.touchStartY = event.changedTouches[0].screenY;
  }, { passive: true });

  this.addEventListener('touchend', (event) => {
    const differenceX =
      event.changedTouches[0].screenX - this.touchStartX;
    const differenceY =
      event.changedTouches[0].screenY - this.touchStartY;

    if (
      Math.abs(differenceX) > 50 &&
      Math.abs(differenceX) > Math.abs(differenceY)
    ) {
      this.changeMedia(differenceX < 0 ? 1 : -1);
    }
  }, { passive: true });

  this.addEventListener('click', (event) => {
    if (
      event.target.closest(
        '.product-media-modal__toggle, .product-modal-mobile-prev, .product-modal-mobile-next'
      )
    ) {
      return;
    }

    const image =
      this.querySelector(
        '.product-media-modal__content [data-media-id].active img'
      ) ||
      this.querySelector('.product-media-modal__content img');

    if (!image || !image.naturalWidth || !image.naturalHeight) {
      return;
    }

    const box = image.getBoundingClientRect();
    const imageRatio = image.naturalWidth / image.naturalHeight;
    const boxRatio = box.width / box.height;

    let visibleWidth;
    let visibleHeight;

    if (imageRatio > boxRatio) {
      visibleWidth = box.width;
      visibleHeight = box.width / imageRatio;
    } else {
      visibleHeight = box.height;
      visibleWidth = box.height * imageRatio;
    }

    const visibleLeft =
      box.left + (box.width - visibleWidth) / 2;
    const visibleRight = visibleLeft + visibleWidth;
    const visibleTop =
      box.top + (box.height - visibleHeight) / 2;
    const visibleBottom = visibleTop + visibleHeight;

    const clickedOutsideVisibleImage =
      event.clientX < visibleLeft ||
      event.clientX > visibleRight ||
      event.clientY < visibleTop ||
      event.clientY > visibleBottom;

    if (clickedOutsideVisibleImage) {
      this.hide();
    }
  }, true);
}

      hide() {
        super.hide();
      }

      show(opener) {
  super.show(opener);
  this.setMobileHeaderOffset();
  this.showActiveMedia();
}

setMobileHeaderOffset() {
  if (window.innerWidth >= 750) return;

  const header =
    document.querySelector('sticky-header') ||
    document.querySelector('.header-wrapper');

  const headerBottom = header
    ? Math.max(0, header.getBoundingClientRect().bottom)
    : 0;

  this.style.setProperty(
    '--mobile-header-offset',
    `${headerBottom}px`
  );
}

      getMediaItems() {
        return Array.from(
          this.querySelectorAll('.product-media-modal__content [data-media-id]')
        );
      }

      changeMedia(direction) {
  if (window.innerWidth >= 750) return;

  const items = this.getMediaItems();
  if (items.length < 2) return;

  let currentIndex = items.findIndex((item) =>
    item.classList.contains('active')
  );

  if (currentIndex === -1) currentIndex = 0;

  const nextIndex =
    (currentIndex + direction + items.length) % items.length;

  const nextItem = items[nextIndex];

  items.forEach((item) => {
    item.classList.remove(
      'active',
      'product-modal-slide-left',
      'product-modal-slide-right'
    );
  });

  nextItem.classList.add('active');
  this.positionMobileCloseButton();

  void nextItem.offsetWidth;

  nextItem.classList.add(
    direction > 0
      ? 'product-modal-slide-right'
      : 'product-modal-slide-left'
  );

  window.setTimeout(() => {
    nextItem.classList.remove(
      'product-modal-slide-left',
      'product-modal-slide-right'
    );
  }, 300);
}
positionMobileCloseButton() {
  if (window.innerWidth >= 750) return;

  const activeMedia = this.querySelector(
    '.product-media-modal__content [data-media-id].active'
  );

  const image = activeMedia?.querySelector('img');
  const closeButton = this.querySelector(
    '.product-media-modal__toggle'
  );

  if (!image || !closeButton) return;

  const updatePosition = () => {
    const modalRect = this.getBoundingClientRect();
    const imageRect = image.getBoundingClientRect();

    const top = Math.max(
      8,
      imageRect.top - modalRect.top + 8
    );

    const right = Math.max(
      8,
      modalRect.right - imageRect.right + 8
    );

    closeButton.style.setProperty(
      '--mobile-close-top',
      `${top}px`
    );

    closeButton.style.setProperty(
      '--mobile-close-right',
      `${right}px`
    );
  };

  if (image.complete) {
    requestAnimationFrame(updatePosition);
  } else {
    image.addEventListener(
      'load',
      () => requestAnimationFrame(updatePosition),
      { once: true }
    );
  }
}
      showActiveMedia() {
        const selectedMediaId =
          this.openedBy.getAttribute('data-media-id');

        this.querySelectorAll('[data-media-id]').forEach((element) => {
          element.classList.remove('active');
        });

        const activeMedia = this.querySelector(
          `[data-media-id="${selectedMediaId}"]`
        );

        if (!activeMedia) return;

        const activeMediaTemplate = activeMedia.querySelector('template');
        const activeMediaContent = activeMediaTemplate
          ? activeMediaTemplate.content
          : null;

        activeMedia.classList.add('active');
        this.positionMobileCloseButton();

        if (window.innerWidth >= 750) {
          activeMedia.scrollIntoView();

          const container = this.querySelector('[role="document"]');
          container.scrollLeft =
            (activeMedia.width - container.clientWidth) / 2;
        }

        if (
          activeMedia.nodeName === 'DEFERRED-MEDIA' &&
          activeMediaContent &&
          activeMediaContent.querySelector('.js-youtube')
        ) {
          activeMedia.loadContent();
        }
      }
    }
  );
}